@import (reference) '../../../../../../constants/spacing.module.less';

.loader {
  height: 50px;
}

.payment-method-header {
  margin-top: @space-16;
}

.add-payment-method-button {
  font-size: 16px;
  height: 48px;
  width: 100%;
  margin: @space-16 0;
}

.payment-method-section {
  margin: @space-8 0 @space-16 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
